import api from '../../config/api';
import { CollectionResponse } from '../../interfaces/api/api';
import { getJsonResponse } from '../../utils/ApiUtils';
import Employee from '../../interfaces/api/Employee';
import useAuth from './useAuth';

const useEmployeeAccess = () => {
  const { fetch } = useAuth();

  const getByIds = async (ids: string[]): Promise<CollectionResponse<Employee>> => {
    const { endpoint, ...options } = api.employee.getByIds(ids);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<Employee>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const get = async (id: string): Promise<Employee> => {
    const { endpoint, ...options } = api.employee.getByIds([id]);

    const response = await fetch(endpoint, options);

    try {
      const collection = await getJsonResponse<CollectionResponse<Employee>>(response);
      const employee = collection.items.pop();

      if (!employee) {
        throw new Error('Employé introuvable');
      }

      return employee;
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const me = async (): Promise<Employee> => {
    const { endpoint, ...options } = api.employee.me();

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<Employee>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const getAll = async (): Promise<CollectionResponse<Employee>> => {
    const { endpoint, ...options } = api.employee.getAll();

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<Employee>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const getAgencyEmployees = async (agencyId: string): Promise<CollectionResponse<Employee>> => {
    const { endpoint, ...options } = api.employee.getAgencyEmployees(agencyId);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<Employee>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return { getAll, getByIds, getAgencyEmployees, get, me };
};

export default useEmployeeAccess;
